import React from 'react';
import './EnviarAccesoModal.css';

const EnviarAccesoModal = ({ open, paciente, onClose, onConfirm, loading }) => {
  if (!open || !paciente) return null;

  const hasPhone = Boolean(paciente.telefono);

  const getDniDigits = (dni) => {
    if (!dni) return '000';
    const digits = dni.replace(/\D+/g, '');
    const last3 = digits.slice(-3);
    return last3.padStart(3, '0');
  };

  const getTempPassword = () => {
    const apellido = paciente.apellido ? paciente.apellido.replace(/[^a-zA-ZñÑ]/g, '').toLowerCase() : '';
    return `${apellido}${getDniDigits(paciente.dni)}`;
  };

  return (
    <div className="eam-overlay">
      <div className="eam-modal">
        <div className="eam-header">
          <h3>Enviar acceso a Historia Clínica</h3>
          <button className="eam-close" onClick={onClose} disabled={loading}>&times;</button>
        </div>
        
        <div className="eam-body">
          <p className="eam-info-text">
            Se enviará un mensaje de WhatsApp con una contraseña temporal para que el paciente pueda cargar su historia clínica.
          </p>

          <div className="eam-data-box">
            <p><strong>Pte:</strong> {paciente.nombre} {paciente.apellido}</p>
            <p><strong>WhatsApp:</strong> {paciente.telefono || <span className="eam-error-text">No registrado</span>}</p>
            <p><strong>Contraseña temporal:</strong> {getTempPassword()}</p>
          </div>

          {!hasPhone && (
            <div className="eam-warning">
              ⚠️ Este paciente no tiene teléfono registrado. No se puede enviar el acceso.
            </div>
          )}
        </div>

        <div className="eam-footer">
          <button className="eam-btn-cancel" onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button 
            className="eam-btn-confirm" 
            onClick={onConfirm} 
            disabled={!hasPhone || loading}
          >
            {loading ? 'Enviando...' : 'Enviar por WhatsApp 📱'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnviarAccesoModal;
